import {
  CalendarCheckIcon,
  CalendarSyncIcon,
  CalendarXIcon,
  ChatIcon,
  CircleDollarIcon,
  CirclePlayIcon,
  CircleXIcon,
  DateSettingsIcon,
  DeleteIcon,
  EarthIcon,
  FileInputIcon,
  FilePlusIcon,
  FileUpIcon,
  FileUserIcon,
  FileXIcon,
  FolderArrowLeftIcon,
  FolderArrowRightIcon,
  FolderCheckIcon,
  FolderDownIcon,
  FolderPenIcon,
  FolderSyncIcon,
  FolderTreeIcon,
  FolderUpIcon,
  FolderXIcon,
  HandCoinsIcon,
  HistoryIcon,
  IconProps,
  LocationMapIcon,
  LocationPinPlusIcon,
  MailCheckIcon,
  MailSearchIcon,
  MailsIcon,
  MailXIcon,
  MultiCoinIcon,
  NotificationsIcon,
  OpenFolderIcon,
  PercentTicketIcon,
  RefreshIcon,
  ReplaceIcon,
  SendIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  SquareDottedMouseIcon,
  SquareXIcon,
  TrendUpDownIcon,
  UserCheckLowIcon,
  UserPlusIcon,
  UserSpeakIcon,
  UserXIcon,
  WarningIcon,
  WrenchIcon,
} from 'components/Icons';

const NOTIFICATION_ICONS = {
  PROJECT_CREATION: FileUpIcon,
  PROJECT_ASSIGNMENT: FolderCheckIcon,
  PROJECT_START_REQUEST: SquareDottedMouseIcon,
  PROJECT_START_AUTHORIZED: CirclePlayIcon,
  PROJECT_OWNERSHIP_REMOVED: FolderXIcon,
  PROJECT_OWNERSHIP_NEW: FolderPenIcon,
  PROJECT_OWNER_CHANGED: TrendUpDownIcon,
  PROJECT_REACTIVATED: FolderSyncIcon,
  PROJECT_TRACKER_SEQUENCE_INIT: FolderTreeIcon,
  PROJECT_NAME_CHANGE: FolderPenIcon,
  PROJECT_CANCELED: SquareXIcon,

  TASK_CREATION: FilePlusIcon,
  TASK_ASSIGNED: UserCheckLowIcon,
  TASK_STATUS_CHANGE: RefreshIcon,
  TASK_CANCELATION: FileXIcon,
  TASK_OWNERSHIP_REMOVED: CircleXIcon,
  TASK_OWNERSHIP_NEW: UserCheckLowIcon,
  NEW_TASK_COMMENT: ChatIcon,
  SUB_TASK_ASSIGN: UserCheckLowIcon,
  SUB_TASK_DATE_CHANGE: CalendarSyncIcon,
  NEW_TASK_FILE: FileInputIcon,
  TASK_SUB_OWNERSHIP_REMOVED: CircleXIcon,
  TASK_SUB_OWNERSHIP_NEW: UserCheckLowIcon,

  SERVICE_CALCULATION_CHANGE: WarningIcon,
  NEW_SERVICE_CREATED: WarningIcon,

  PROJECT_STARTED: FolderArrowRightIcon,
  PROJECT_STARTED_TASK_UNASSIGNED: FileUserIcon,
  PROJECT_STARTED_TASK: OpenFolderIcon,

  REPRICE_REQUEST: CircleDollarIcon,
  REPRICE_PRICING: HandCoinsIcon,

  OUTSOURCE_ADDITION_REQUEST: ShoppingBagIcon,
  OUTSOURCE_APPROVAL: ShoppingCartIcon,
  OUTSOURCE_REJECTION: DeleteIcon,

  EXPECTED_DATE_CHANGE_REQUEST: DateSettingsIcon,
  EXPECTED_DATE_CHANGE_RESPONSE: CalendarSyncIcon,

  PROJECT_DATE_CHANGE_REQUEST: HistoryIcon,
  PROJECT_DATE_CHANGE_APPROVED: CalendarCheckIcon,
  PROJECT_DATE_CHANGE_DENIED: CalendarXIcon,

  PROJECT_TEAM_CHANGE_REQUEST: FolderUpIcon,
  PROJECT_TEAM_CHANGE_ANSWERED: FolderDownIcon,
  PROJECT_OWNERSHIP_CHANGE_TEAM_CHANGED: FolderArrowLeftIcon,
  PROJECT_TEAM_CHANGE_ASSIGNMENT: FolderCheckIcon,
  PROJECT_TEAM_CHANGE_TASK_OWNER: UserCheckLowIcon,

  PROJECT_COUNTRY_ADDITION_COMPLETION: LocationMapIcon,
  PROJECT_COUNTRY_ADDITION_REQUEST: LocationPinPlusIcon,
  PROJECT_COUNTRY_ADDITION_RESPONSE: LocationPinPlusIcon,

  INVOICE_CONTROL_ASSIGNMENT: FolderCheckIcon,
  INVOICE_CONTROL_REMOVED: FolderXIcon,
  PROJECT_SENT_TO_INVOICE: SendIcon,
  INVOICE_CONTROL_REACTIVATION_AFTER_REPRICE: ReplaceIcon,
  INVOICE_CONTROL_REACTIVATION_AFTER_NEW_SERVICE: WrenchIcon,
  INVOICE_CONTROL_REACTIVATION_AFTER_NEW_COUNTRY: EarthIcon,
  INVOICE_CANCELATION_REQUEST: FileXIcon,
  INVOICE_CONTROL_CANCEL_REQUEST: FileXIcon,
  INVOICE_CONTROL_CANCEL_RESPONSE: FolderXIcon,

  PROJECT_INVOICE_DISCOUNT_REQUEST: PercentTicketIcon,
  PROJECT_INVOICE_DISCOUNT_RESPONSE: PercentTicketIcon,

  QUOTATION_REQUEST_CREATION: MultiCoinIcon,
  QUOTATION_REQUEST_ANSWER: HandCoinsIcon,

  PROJECT_ISSUE_CREATED: WarningIcon,
  PROJECT_ISSUE_USER_ADDED: UserPlusIcon,
  PROJECT_ISSUE_USER_REMOVED: UserXIcon,
  PROJECT_ISSUE_NEW_COMMENT: ChatIcon,

  RECRUITMENT_REQUESTED: UserSpeakIcon,
  RECRUITMENT_COMMENT: ChatIcon,
  RECRUITMENT_DENIED: MailXIcon,
  RECRUITMENT_ASSIGNED: MailSearchIcon,
  RECRUITMENT_APPROVED: MailSearchIcon,
  RECRUITMENT_STARTED: MailsIcon,
  RECRUITMENT_FINISHED: MailCheckIcon,
} as Record<string, typeof FileUpIcon>;

export function NotificationIcon({ type, ...props }: { type: string } & IconProps) {
  const Icon = NOTIFICATION_ICONS[type] || NotificationsIcon;

  return <Icon {...props} />;
}
